import { RestSlice } from '../../../../../redux/rest.slice';
import { IppReportPackageTemplateElement } from '@rcp/types';
import { Resource, localizationService } from 'src/services';

export const ippCertificationsSlice = new RestSlice<IppReportPackageTemplateElement>(
	localizationService.getLocalizedString('ipp.reportPackage.reportPackageElements.certifications'),
	Resource.IppReportPackageReportElementTypes
);
export default ippCertificationsSlice.rests.reducer;
